import {Employee, User, Vehicle} from "domain-models"
import _ from "lodash"

export const hasFlag = (object: Vehicle | User | Employee, path: string, bit: number): boolean => {
  return !!(_.get(object, path, 0) & bit)
}
